import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import { AppHasAccessDirective } from '@core/directives/app-has-access.directive';
import { HasPermissionPipe } from '@core/pipes/has-permission.pipe';
import { ImageProcessorPipe } from '@core/pipes/image-processor.pipe';
import { ClusterInfoPopupComponent } from '@shared/cluster-info-popup/cluster-info-popup.component';
import { LabelPopupComponent } from '@shared/label-form-popup/label-form-popup.component';
import {ButtonModule} from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import {SharedMaterialModule} from './shared-material.module';
import {SharedPrimeNgModule} from './shared-prime-ng.module';
import {MapDisplayComponent} from "./map-display/map-display.component";
import {NgxMapboxGLModule} from "ngx-mapbox-gl";
import {PolygonPopupComponent} from "./polygon-popup/polygon-popup.component";
import {MapDataTableComponent} from "./map-data-table/map-data-table.component";
import {NewDataCenterPopupComponent} from "./new-data-center-popup/new-data-center-popup.component";
import {GeoFilterComponent} from "./geo-filter/geo-filter.component";
import {ProvidersTableComponent} from "./providers-table/providers-table.component";
import {
  ProvidersDatacentersDetailsComponent
} from "./providers-datacenters-details/providers-datacenters-details.component";
import {MapMarkersComponent} from "./map-markers/map-markers.component";
import {MapMarkersGLComponent} from "./map-markers/map-markers-gl.component";
import {OnlyNumberDirective} from "@core/directives/only-number.directive";
import {UserCardComponent} from "./user-card/user-card.component";
import {UsersListComponent} from "./users-list/users-list.component";
import {KeyFilterModule} from "primeng/keyfilter";
import {LocationDirective} from "@core/directives/location.directive";

import { ResizableModule } from 'angular-resizable-element';
import { LoadingComponent } from './loading/loading.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AvailabilityZonePopupComponent } from './availability-zone-popup/availability-zone-popup.component';
import { AvailabilityZonesSidebarComponent } from './availability-zone-table/availability-zones-sidebar.component';
import { CheckboxModule } from 'primeng/checkbox';
import {FilesTableComponent} from "./files-table/files-table.component";
import { TooltipModule } from 'primeng/tooltip';
import {InfoPopupComponent} from "./info-popup/info-popup.component";
import { ScrollingModule } from '@angular/cdk/scrolling';
import {AccessDeniedComponent} from "@shared/access-denied/access-denied.component";
import {FolderConfigComponent} from "@shared/folder-config/folder-config.component";
import {TrimInputDirective} from "@core/directives/trim-input.directive";
import {ProvidersTableAuxComponent} from "@shared/providers-table-aux/providers-table-aux.component";

@NgModule({
  declarations: [
    MapDisplayComponent,
    PolygonPopupComponent,
    MapDataTableComponent,
    NewDataCenterPopupComponent,
    GeoFilterComponent,
    ProvidersTableComponent,
    ProvidersDatacentersDetailsComponent,
    MapMarkersComponent,
    MapMarkersGLComponent,
    OnlyNumberDirective,
    UserCardComponent,
    UsersListComponent,
    LocationDirective,
    AppHasAccessDirective,
    LoadingComponent,
    AvailabilityZonePopupComponent,
    AvailabilityZonesSidebarComponent,
    FilesTableComponent,
    InfoPopupComponent,
    ClusterInfoPopupComponent,
    AccessDeniedComponent,
    FolderConfigComponent,
    ProvidersTableAuxComponent,
    LabelPopupComponent,
  ],
  imports: [
    SharedMaterialModule,
    SharedPrimeNgModule,
    ButtonModule,
    FormsModule,
    CommonModule,
    NgxMapboxGLModule,
    KeyFilterModule,
    ResizableModule,
    ProgressSpinnerModule,
    CheckboxModule,
    TooltipModule,
    ScrollingModule,
    TrimInputDirective,
    HasPermissionPipe,
    ImageProcessorPipe,
    InputText
  ],
  exports: [
    SharedMaterialModule,
    SharedPrimeNgModule,
    ButtonModule,
    FormsModule,
    MapDisplayComponent,
    PolygonPopupComponent,
    MapDataTableComponent,
    NewDataCenterPopupComponent,
    GeoFilterComponent,
    ProvidersTableComponent,
    ProvidersDatacentersDetailsComponent,
    MapMarkersComponent,
    MapMarkersGLComponent,
    OnlyNumberDirective,
    UserCardComponent,
    UsersListComponent,
    LocationDirective,
    AppHasAccessDirective,
    LoadingComponent,
    AvailabilityZonePopupComponent,
    AvailabilityZonesSidebarComponent,
    CheckboxModule,
    FilesTableComponent,
    InfoPopupComponent,
    ClusterInfoPopupComponent,
    FolderConfigComponent,
    LabelPopupComponent
  ]

})
export class SharedModule {
}
